export const environment = {
    production: true,
    "path": "/keno",
    "api": "/Api",
    endpoint: ''
};



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/environments/environment.ts